var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tooltip-lg",class:{show: _vm.show, animate: _vm.animate, primary: _vm.primary === '', secondary: _vm.secondary === ''},style:({ left: _vm.left + 'px', top: _vm.top + 'px'}),attrs:{"data-placement":_vm.placement.split(' ')[0]}},[_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a1cc1942","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/TooltipLg.vue
// module id = null
// module chunks = 